import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import SaveIcon from "@material-ui/icons/SaveAlt";
import React from "react";
import { SecuredListButton } from "../../Buttons/SecuredListButton";
import { GetApp } from "@material-ui/icons";
import { IndexViewComponent } from "./IndexView";
import { inject } from "mobx-react";

export interface DefaultToolbarButtonsConfig {
  delete: boolean;
  export: boolean;
}

const Button = inject("i18n")(({ i18n: i18n, title: titleArgs, ...props }) => {
  const title = i18n.t(...titleArgs);
  return <SecuredListButton title={title} {...props} />;
});

export const defaultToolbarButtonsCreator = (
  config: DefaultToolbarButtonsConfig
) => {
  return (props: any) => defaultToolbarButtons(props, config);
};
export const defaultToolbarButtons = (
  indexProps: IndexViewComponent<any, any>,
  config: DefaultToolbarButtonsConfig = {
    delete: true,
    export: false
  }
) => (close: () => void) => {
  const arr = [];
  const remove = (e: any) => {
    indexProps.callbackDelete(indexProps.props.dataSource.selected);
    close();
  };

  const exportSelected = () => {
    indexProps.props.dataSource.exportSelected(
      "text/csv",
      indexProps.props.dataSource.selected
    );
    close();
  };

  const exportAll = () => {
    indexProps.props.dataSource.exportAll(
      "text/csv",
      indexProps.prepareParams()
    );
    close();
  };

  if (config.export) {
    arr.push(
      <Button
        key={"export all"}
        title={["lego:views.index.toolbar.exportAll", "Export All"]}
        callbackFunction={exportAll}
      >
        <GetApp />
      </Button>
    );
  }

  if (config.export) {
    arr.push(
      <Button
        key={"export"}
        title={["lego:views.index.toolbar.export", "Export"]}
        callbackFunction={exportSelected}
        disabled={indexProps.props.dataSource.selected.length === 0}
      >
        <SaveIcon />
      </Button>
    );
  }

  if (config.delete) {
    arr.push(
      <Button
        key={"delete"}
        title={["lego:views.index.toolbar.delete", "Delete"]}
        callbackFunction={remove}
        disabled={indexProps.props.dataSource.selected.length === 0}
      >
        <DeleteIcon />
      </Button>
    );
  }

  return arr;
};
